import { useTranslation } from 'react-i18next';
import { PassengerType } from '../Summary.model';
import { SummarySubItem } from './summary-sub-item/SummarySubItem';
import { Box } from '../..';
import { SummaryArticle } from './summary-article/SummaryArticle';
import styles from '../Summary.module.css';

type PassengerItemProps = { passenger: PassengerType; onClick: (passengerType: PassengerType['type']) => void };

export const PassengerItem = (props: PassengerItemProps) => {
	const { t } = useTranslation('summary');
	const { passenger } = props;
	const passengerLiteral: ResourcesType<'summary'> =
		passenger.names.length > 1 ? `SOME_${passenger.type}` : passenger.type;
	return (
		<SummarySubItem
			icon={passenger.type === 'ADULT' ? 'pasajero-masculino' : passenger.type === 'CHILD' ? 'ninos' : 'bebes'}
			text={t(passengerLiteral)}
			number={passenger.names.length}
		>
			<Box className={styles.summary_passengers}>
				{passenger.names.map((passenger, index) => {
					return <SummaryArticle key={`passenger_${String(index)}`} text={passenger}></SummaryArticle>;
				})}
			</Box>
			{passenger.avios && (
				<SummaryArticle
					text={t('AVIOS')}
					price={`${passenger.avios} ${String(t('AVIOS'))}`}
					amount={passenger.names.length}
					amountEnd
				></SummaryArticle>
			)}
			<SummaryArticle
				text={t('FARE')}
				price={passenger.fare}
				amount={passenger.names.length}
				amountEnd
			></SummaryArticle>
			<SummaryArticle
				text={t('OPERATOR_FEES')}
				price={passenger.taxes}
				onClick={() => {
					props.onClick(passenger.type);
				}}
			></SummaryArticle>
		</SummarySubItem>
	);
};
PassengerItem.displayName = 'PassengerItem';
